import React from 'react';
import { Tag, X } from 'lucide-react';

const TagDisplay = ({ 
  tags = [], 
  maxTags = 3, 
  size = 'sm', 
  color = 'blue',
  showCount = false,
  onRemove = null,
  className = '' 
}) => {
  if (!tags || tags.length === 0) return null;

  const sizeClasses = {
    xs: 'text-xs px-1.5 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  };

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-800 border-blue-200',
    purple: 'bg-[var(--pf-accent-soft)] text-[var(--pf-accent)] border-[color-mix(in_srgb,var(--pf-accent)_25%,var(--pf-border))]',
    green: 'bg-green-100 text-green-800 border-green-200',
    orange: 'bg-orange-100 text-orange-800 border-orange-200',
    pink: 'bg-pink-100 text-pink-800 border-pink-200',
    gray: 'bg-gray-100 text-gray-800 border-gray-200',
    red: 'bg-red-100 text-red-800 border-red-200',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    indigo: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    teal: 'bg-teal-100 text-teal-800 border-teal-200'
  };

  const tagColors = ['blue', 'purple', 'green', 'orange', 'pink', 'indigo', 'teal'];
  
  const displayTags = tags.slice(0, maxTags);
  const remainingCount = tags.length - maxTags;

  const getTagColor = (index) => {
    return tagColors[index % tagColors.length];
  };

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {displayTags.map((tag, index) => {
        const tagColor = color === 'auto' ? getTagColor(index) : color;
        return (
          <span
            key={`${tag}-${index}`}
            className={`inline-flex items-center gap-1 rounded-full border font-medium ${sizeClasses[size]} ${colorClasses[tagColor]}`}
          >
            <Tag className="w-3 h-3" />
            {tag}
            {onRemove && (
              <button
                onClick={() => onRemove(tag)}
                className="ml-1 hover:bg-black/10 rounded-full p-0.5 transition-colors"
              >
                <X className="w-3 h-3" />
              </button>
            )}
          </span>
        );
      })}
      
      {showCount && remainingCount > 0 && (
        <span className={`inline-flex items-center rounded-full border ${sizeClasses[size]} ${colorClasses.gray}`}>
          +{remainingCount} more
        </span>
      )}
    </div>
  );
};

export default TagDisplay;
